import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	saveButtonText: {
		id: 'recur-work-item.popup.content.save-button-text-non-final',
		defaultMessage: 'Save',
		description: 'Text for recurring work popup save button',
	},
	cancelButtonText: {
		id: 'recur-work-item.popup.content.cancel-button-text-non-final',
		defaultMessage: 'Cancel',
		description: 'Text for recurring work popup cancel button',
	},
	deleteButtonText: {
		id: 'recur-work-item.popup.content.delete-button-label-non-final',
		defaultMessage: 'Delete',
		description: 'Text for recurring work popup delete button',
	},
	recurFieldsLabel: {
		id: 'recur-work-item.popup.content.form-field-recur-label-non-final',
		defaultMessage: 'Recur',
		description: 'Label for recur work item popup form field.',
	},
	setToRecur: {
		id: 'recur-work-item.set-to-recur-non-final',
		defaultMessage: 'Set to recur',
		description: 'Label for a set recurring menu item',
	},
	recursDaily: {
		id: 'recur-work-item.recurs-daily-non-final',
		defaultMessage: 'Recurs daily',
		description: 'Label for a daily recurring menu item',
	},
	recursEveryWeekday: {
		id: 'recur-work-item.recurs-every-weekday-non-final',
		defaultMessage: 'Every weekday (Monday to Friday)',
		description: 'Label for a every weekday recurring menu item',
	},
	recursWeekly: {
		id: 'recur-work-item.recurs-weekly-non-final',
		defaultMessage: 'Recurs weekly',
		description: 'Label for a weekly recurring menu item',
	},
	recursFortnightly: {
		id: 'recur-work-item.recurs-fortnightly-non-final',
		defaultMessage: 'Recurs fortnightly',
		description: 'Label for a fortnightly recurring menu item',
	},
	recursOnComplete: {
		id: 'recur-work-item.recurs-on-complete-non-final',
		defaultMessage: 'Recurs when completed',
		description: 'Label for a recurring on complete menu item',
	},
});
